export default __webpack_public_path__ + "static/media/goop.5d297087.gif";